import React, {useEffect, useState} from 'react';
import {Modal, ModalHeader, ModalBody, ModalFooter, Button} from 'reactstrap';
import {useTranslation} from 'react-i18next';
import {FACT_TYPE_ORDER, factTypeLabelKey} from './factConstants';

const MAX_STATEMENT_LENGTH = 2000;

// Modal para cargar un hecho a mano (la agencia lo afirma). Nace APROBADO e interno
// (la visibilidad se ajusta después en la biblioteca). Tipo + texto.
export function FactCreateModal({isOpen, saving, toggle, onCreate}) {
    const {t} = useTranslation();
    const [factType, setFactType] = useState('OBJECTIVE');
    const [statement, setStatement] = useState('');

    useEffect(() => {
        if (isOpen) {
            setFactType('OBJECTIVE');
            setStatement('');
        }
    }, [isOpen]);

    const trimmed = statement.trim();
    const valid = trimmed.length > 0 && trimmed.length <= MAX_STATEMENT_LENGTH;

    return (
        <Modal isOpen={isOpen} toggle={toggle}>
            <ModalHeader toggle={toggle}>{t('client_memory.create_modal.title')}</ModalHeader>
            <ModalBody>
                <div className="modal-section">
                    <div className="form-row">
                        <label>{t('client_memory.create_modal.type_label')}</label>
                        <select className="form-control" value={factType}
                                onChange={(e) => setFactType(e.target.value)}>
                            {FACT_TYPE_ORDER.map((tp) => (
                                <option key={tp} value={tp}>{t(factTypeLabelKey(tp))}</option>
                            ))}
                        </select>
                    </div>
                    <div className="form-row">
                        <label>{t('client_memory.create_modal.statement_label')}</label>
                        <textarea
                            className="form-control"
                            rows={4}
                            value={statement}
                            maxLength={MAX_STATEMENT_LENGTH}
                            placeholder={t('client_memory.create_modal.statement_placeholder')}
                            onChange={(e) => setStatement(e.target.value)}
                        />
                        <span className="cmem-char-count">{`${trimmed.length}/${MAX_STATEMENT_LENGTH}`}</span>
                    </div>
                </div>
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={toggle} disabled={saving}>
                    {t('client_memory.action.cancel')}
                </Button>
                <button type="button" className="btn -alt" disabled={!valid || saving}
                        onClick={() => onCreate({fact_type: factType, statement: trimmed})}>
                    {t('client_memory.action.add')}
                </button>
            </ModalFooter>
        </Modal>
    );
}
